import { Icon, IconProps } from ".";

export const Avatar = (props: IconProps) => {
  return (
    <Icon {...props}>
      <>
        <path d="M6.60005 6.60005H8.40005V8.40005H6.60005V6.60005Z" />
        <path d="M8.40005 6.60005H10.2V8.40005H8.40005V6.60005Z" />
        <path d="M8.40005 4.80005H10.2V6.60005H8.40005V4.80005Z" />
        <path d="M10.2 6.60005H12V8.40005H10.2V6.60005Z" />
        <path d="M12 6.60005H13.8V8.40005H12V6.60005Z" />
        <path d="M8.40005 13.8H10.2V15.6H8.40005V13.8Z" />
        <path d="M13.8 13.8H15.6V15.6H13.8V13.8Z" />
        <path d="M4.80005 12H6.60005V13.8H4.80005V12Z" />
        <path d="M17.4 13.8H19.2V15.6H17.4V13.8Z" />
        <path d="M17.4 12H19.2V13.8H17.4V12Z" />
        <path d="M4.80005 13.8H6.60005V15.6H4.80005V13.8Z" />
        <path d="M10.2 17.4H12V19.2H10.2V17.4Z" />
        <path d="M10.2 15.6H12V17.4H10.2V15.6Z" />
        <path d="M12 17.4H13.8V19.2H12V17.4Z" />
        <path d="M12 15.6H13.8V17.4H12V15.6Z" />
        <path d="M10.2 10.2H12V12H10.2V10.2Z" />
        <path d="M12 10.2H13.8V12H12V10.2Z" />
        <path d="M13.8 6.60005H15.6V8.40005H13.8V6.60005Z" />
        <path d="M13.8 4.80005H15.6V6.60005H13.8V4.80005Z" />
        <path d="M8.40005 8.40005H10.2V10.2H8.40005V8.40005Z" />
        <path d="M13.8 8.40005H15.6V10.2H13.8V8.40005Z" />
        <path d="M15.6 6.60005H17.4V8.40005H15.6V6.60005Z" />
      </>
    </Icon>
  );
};
